import React from 'react';
import './skeleton.scss';

interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  variant?: 'text' | 'circular' | 'rectangular';
  className?: string;
}

/**
 * Reusable skeleton primitive for loading states.
 * Compose multiple Skeleton components to create section-specific loading layouts.
 */
const Skeleton: React.FC<SkeletonProps> = ({
  width,
  height,
  variant = 'rectangular',
  className = '',
}) => {
  const style: React.CSSProperties = {};
  
  if (width) {
    style.width = typeof width === 'number' ? `${width}px` : width;
  }
  if (height) {
    style.height = typeof height === 'number' ? `${height}px` : height;
    style.minHeight = typeof height === 'number' ? `${height}px` : height;
  }

  return (
    <div 
      className={`skeleton skeleton--${variant} ${className}`}
      style={style}
      aria-hidden="true"
    />
  );
};

export default Skeleton;
